import {dragGame} from 'dragGame/dragGame'
import {memoryGame} from 'memoryGame/memoryGame'
import {intro} from 'intro/intro'

const map = {
  "init": {
    "onComplete": intro
  },
  "intro": {
    "onComplete": dragGame
  },
  "dragGame": {
    "onComplete": memoryGame
  }
}


function createMap() { return map }
export {createMap}
